import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../services/common_Service/common.service';
import { errorMessages } from '../../../../../configurations/errorMessages';
import { SessionHelper } from '../../../../../services/localstorage';
import * as moment from 'moment';

@Component({
  selector: 'app-addLan',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentLan implements OnInit {

    @Output() updateSend = new EventEmitter<any>();

    @Input() set contentId(value: any) {
        this.isLanguageSubmitted = false;

        if (value == 'reset') {
            this.resetForm();
        } else if (value != undefined) {
            if (value != 'null') {
                this.showCreateNewButton('hide');
            }
            this.onLoad(value);
        }
    }

    createLanguageForm: FormGroup;
    errorMessages = errorMessages;

    loader: boolean = false;
    isCreateNewShow: boolean = false;
    contentReadyToReview: boolean = false;
    isLanguageSubmitted: boolean = false;
    update: boolean = false;
    editCreate: boolean = false;
    isHeaderVisible: boolean = false;
    isGroupSearch: boolean = false;

    id: any = 'null';
    assetPath: any;
    languageTitle: any = '';
    createdDate: any = '-';
    shareMassage: any;
    mainObj: any = {};

    languageList: any = [];
    roleAsses: any = {};
    roleConfiguration: any = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private toastrService: ToastrService,
        private router: Router,
        private commonService: CommonService,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        this.initRoleAccess();
        this.initForm();

        this.activatedRoute.params.subscribe((params: Params) => {
            this.assetPath = params['id'];
            this.getAllLanguages();

            if (this.assetPath == undefined || this.assetPath == 'null') {
                this.update = false;
                this.isHeaderVisible = false;
                this.editCreate = this.roleAsses.languageCreate;
                this.setHeaderTitle('Create Language');
            } else if (this.assetPath == 'reset') {
                this.resetForm();
            } else {
                this.update = true;
                this.isHeaderVisible = true;
                this.editCreate = this.roleAsses.languageEdit;
                this.onLoad(this.assetPath);
            }
        });
    }

    get l() { return this.createLanguageForm.controls; }

    initRoleAccess() {
        this.roleAsses.language = true;
        this.roleAsses.languageCreate = true;
        this.roleAsses.languageEdit = true;

        this.roleConfiguration = SessionHelper.getRole() || [];
        const languageRole = this.roleConfiguration.find((element) => element.pageTitle == 'Language');

        if (languageRole) {
            this.roleAsses.language = languageRole.isView == 1;
            this.roleAsses.languageCreate = languageRole.isCreate == 1;
            this.roleAsses.languageEdit = languageRole.isEdit == 1;
        }
    }

    initForm() {
        this.createLanguageForm = this.formBuilder.group({
            languageName: ['', Validators.required],
            languageCode: [''],
            id: [''],
            contentState: ['In-Progress'],
            publisherState: ['Un-published'],
            reviewerState: ['Un-approved'],
            created_by: [localStorage.getItem('ud')]
        });
    }

    onLoad(id) {
        this.id = id;

        let uid = localStorage.getItem('ud');
        if (uid === undefined || uid == null) {
            this.router.navigate(['/login']);
            return;
        }

        if (id != 'null' && id != undefined) {
            this.update = true;
            this.editCreate = this.roleAsses.languageEdit;
            this.getLanguageInfo(id);
        } else {
            this.update = false;
            this.editCreate = this.roleAsses.languageCreate;
            this.setHeaderTitle('Create Language');
        }
    }

    getLanguageInfo(id) {
        this.commonService.changeloader(true);

        this.commonService.getGlobalLanguage({ languageId: id }, 0, 1)
        .subscribe((result: any) => {
            this.commonService.changeloader(false);

            const data = result && result.data && result.data.data && result.data.data.length ? result.data.data[0] : null;
            if (!data) {
                this.toastrService.error('Language not found.');
                this.router.navigate(['/master/language/list']);
                return;
            }

            this.mainObj = data;
            this.languageTitle = data.languageName || data.title || '';
            this.createdDate = data.created_date ? moment(data.created_date).format('MM-DD-YYYY') : '-';

            this.createLanguageForm.controls['languageName'].setValue(data.languageName || data.title || '');
            this.createLanguageForm.controls['languageCode'].setValue(data.languageCode || data.langCode || data.code || '');
            this.createLanguageForm.controls['id'].setValue(data.languageId || data.id || id);
            this.createLanguageForm.controls['publisherState'].setValue(data.publisherState || 'Un-published');
            this.createLanguageForm.controls['reviewerState'].setValue(data.reviewerState || 'Un-approved');

            if (data.contentState == null || data.contentState == '' || data.contentState == undefined) {
                this.createLanguageForm.controls['contentState'].setValue('In-Progress');
            } else {
                this.createLanguageForm.controls['contentState'].setValue(data.contentState);
            }

            this.setHeaderTitle(this.languageTitle);
        }, () => {
            this.commonService.changeloader(false);
            this.toastrService.error('Unable to load language.');
        });
    }

    getAllLanguages() {
        this.commonService.getGlobalLanguage({}, 0, 100000)
        .subscribe((result: any) => {
            this.languageList = result && result.data && result.data.data ? result.data.data : [];
        });
    }

    onContentReadyToReview() {
        this.isLanguageSubmitted = true;

        if (this.createLanguageForm.invalid) {
            this.contentReadyToReview = false;
            return;
        }

        this.contentReadyToReview = true;
        this.shareMassage = 'review';
    }

    isContentReadyToReviewReceived(event) {
        this.contentReadyToReview = false;

        if (event == 'No') {
            return;
        }

        if (event == 'Yes') {
            this.createLanguageForm.controls['contentState'].setValue('Completed');
        }

        if (event == 'Cancel') {
            this.createLanguageForm.controls['contentState'].setValue('In-Progress');
        }

        this.saveLanguage();
    }

    saveLanguage() {
        this.isLanguageSubmitted = true;

        if (this.createLanguageForm.invalid) {
            return;
        }

        this.commonService.changeloader(true);

        const payload = Object.assign({}, this.createLanguageForm.value, {
            languageId: this.id != 'null' && this.id != undefined ? this.id : undefined,
            languageName: this.createLanguageForm.value.languageName,
            langId: undefined
        });

        if (this.update == true) {
            if (this.roleAsses.languageEdit == false) {
                this.toastrService.success('no access to edit.');
                this.commonService.changeloader(false);
                return;
            }

            payload.id = this.id;

            this.commonService.updateGlobalLanguage(payload)
            .subscribe((result: any) => {
                this.commonService.changeloader(false);
                this.toastrService.success('Language Updated Successfully.');
                this.router.navigate(['/master/language/list']);
            }, () => {
                this.commonService.changeloader(false);
                this.toastrService.error('Unable to update language.');
            });
        } else {
            if (this.roleAsses.languageCreate == false) {
                this.toastrService.success('no access to create.');
                this.commonService.changeloader(false);
                return;
            }

            delete payload.id;

            this.commonService.insertGlobalLanguage(payload)
            .subscribe((result: any) => {
                this.commonService.changeloader(false);
                this.toastrService.success('Language Created Successfully.');
                this.router.navigate(['/master/language/list']);
            }, () => {
                this.commonService.changeloader(false);
                this.toastrService.error('Unable to create language.');
            });
        }
    }

    resetForm() {
        this.commonService.changeloader(false);
        this.update = false;
        this.isLanguageSubmitted = false;
        this.initForm();
        this.updateSend.emit();
        this.showCreateNewButton('show');
    }

    showCreateNewButton(isShow) {
        this.isCreateNewShow = isShow == 'show';
    }

    onPrevious() {
        const index = this.languageList.findIndex(obj => obj.languageId == this.assetPath);
        if (index !== -1 && index > 0) {
            this.assetPath = this.languageList[index - 1].languageId;
            this.router.navigate(['/master/language/add', this.assetPath]);
        }
    }

    onNext() {
        const index = this.languageList.findIndex(obj => obj.languageId == this.assetPath);
        if (index !== -1 && index < this.languageList.length - 1) {
            this.assetPath = this.languageList[index + 1].languageId;
            this.router.navigate(['/master/language/add', this.assetPath]);
        }
    }

    gotoAsset(item) {
        const filtered = this.languageList.filter(p => p.languageName === item);
        if (filtered.length > 0) {
            this.assetPath = filtered[0].languageId;
            this.router.navigate(['/master/language/add', this.assetPath]);
        }
    }

    private setHeaderTitle(pageName) {
        let headerTitle = {
            title: 'Master',
            subTitle: 'Language',
            pageName: pageName
        };

        this.commonService.changeHeaderTitle(headerTitle);
    }
}
